export default __webpack_public_path__ + "dgh@2x.9f6c842c.png";